import { cva } from '@vizit/theme';

const gridClasses = cva({
  base: ['grid gap-x-8 gap-y-16 auto-rows-auto', 'grid-cols-[repeat(auto-fill,148px)]'],
});

const containerClasses = cva({
  base: 'w-full flex flex-col gap-5 mb-32',
});

const assetWrapperClasses = cva({
  base: 'w-[148px] aspect-square',
});

const loadingDropTargetClasses = cva({
  base: 'h-28 w-full',
  variants: {
    isOriginalView: {
      true: 'border-none rounded-xs bg-gray-dark-25',
    },
  },
});

const sortableAssetWrapperClasses = cva({
  base: ['relative', 'w-[148px] aspect-square'],
  variants: {
    canAcceptDrop: {
      true: 'ring-2 ring-gray-modern-600 transition-all duration-300',
      false: '',
    },
    isOver: {
      true: '',
      false: '',
    },
  },
  compoundVariants: [
    {
      canAcceptDrop: true,
      isOver: true,
      className: 'ring-2 ring-gray-modern-600 transition-all duration-300',
    },
  ],
});

export { gridClasses, containerClasses, assetWrapperClasses, sortableAssetWrapperClasses, loadingDropTargetClasses };
